<template>
  <div class="table-container">
    <h3 style="margin-bottom: 16px; color: #333;">套利拖拉机注册步骤</h3>
    
    <!-- 飞书文档嵌入 -->
    <div class="feishu-doc-container">
      <div class="doc-header">
        <p style="margin-bottom: 12px; color: #666; line-height: 1.6;">
          LOF基金套利拖拉机（1 拖 6）保姆级教程
        </p>
        <p style="margin-bottom: 16px; color: #888; font-size: 12px;">
          文末有LOF套利交流群联系方式，有需要的可以扫码添加微信备注LOF拉你进群，谢绝广告，只做交流，广告勿扰
        </p>
        <div class="doc-link">
          <a 
            href="https://wcnui8a5lcos.feishu.cn/wiki/VIlBwrd9wiePkLkvL3Pc4rpenJv?from=from_copylink" 
            target="_blank"
            class="external-link"
          >
            <i class="el-icon-link"></i> 飞书在线版文档（点击在新窗口打开）
          </a>
        </div>
      </div>
      <h1 style="margin-bottom: 16px; color: #333;">注册</h1>
      <h2 style="margin-bottom: 16px; color: #333;">第一步：开通华宝证券账户 </h2>
      <h3 style="margin-bottom: 16px; color: #ff0000;">必须要用有费率优惠的股票账户基金套利的股票账户要求，必须场内申购一折优惠，买卖基金免5，否则就是辛辛苦苦给券商打工。</h3>
      备注华宝证券费率情况如下：
      <h4 style="margin-bottom: 16px; color: #ff0000;">交易手续费：</h4>
      <h5 style="margin-bottom: 16px; color: #ff0000;">1、股票万分之1.154，起点5元；（存入1.2万后可找我申请调2元起点优惠）套利不需要这个 </h5>
      <h5 style="margin-bottom: 16px; color: #ff0000;">2、ETF/LOF基金买卖万分之1，起点0.2元，LOF场内申购1折，一拖六套利必备利器</h5>
      <h5 style="margin-bottom: 16px; color: #ff0000;">3、可转债上海万0.44，深圳万0.8，起点0.5元</h5>
      <h5 style="margin-bottom: 16px; color: #ff0000;">4、逆回购一天期十万分之一</h5>
      <h5 style="margin-bottom: 16px; color: #ff0000; font-weight: bold;"> 基金开户默认申购一折卖出两毛起已调好，不用单独调整。如有其他费率相关问题，可以扫码联系咨询。</h5>
      <h3  style="margin-bottom: 16px; color: #ff0000; font-weight: bold;">开户二维码如下，先微信识别输入手机号接收验证码绑定优惠费率（码失效了联系微信补码）</h3>
      <img :src="huabapRegImg" alt="华宝证券开户二维码" class="qr-image">
      <h3 style="margin-bottom: 16px; color: #333;">扫码识别绑定过后直接下载或者应用商店去下载【华宝智投】手机号登录进行开户流程 </h3>
      <h3 style="margin-bottom: 16px; color: #333;">都是可以享受默认一折佣金费率优惠，满足基金套利低佣要求。 </h3>
      <h3 style="margin-bottom: 16px; color: #333;">基金套利的股票账户要求，必须场内申购一折优惠，买卖基金免5，否则就是辛辛苦苦给券商打工。</h3>
      <div class="inline-heading">
        <h3 style="margin: 0; color: #333; display: inline;">华宝开户优先选择第二个</h3>
        <h3 style="margin: 0; color: #ff0000; display: inline;">【理财账户】</h3>
        <h3 style="margin: 0; color: #333; display: inline;">开户没有回访电话，这步如果没有就忽略</h3>
      </div>
      <h3 style="margin-bottom: 16px; color: #ff0000;">开通登记账户，全选 </h3>
      <div class="inline-heading">
        <img :src="licaiImg" alt="理财账户" class="qr-image" style="width: 150px; height: 100%;">
        <img :src="zhanghuleixingImg" alt="账户类型全选" class="qr-image" style="width: 150px; height: 100%;">
      </div>
      <h3 style="margin-bottom: 16px; color: #333;">提交结束是这样的</h3>
      <img :src="kaihushouliImg" alt="开户受理" class="qr-image">
      <div class="inline-heading">
        <h3 style="margin-bottom: 16px; color: #333;">如果操作失误选到第三个</h3>
        <h3 style="margin-bottom: 16px; color: #ff0000;">【股票账户】</h3>
        <h3 style="margin-bottom: 16px; color: #333;">按照默认上海和深圳都勾选上，也不影响只是会多接一个开户回访电话，自己多注意。</h3>
      </div>
      <div class="inline-heading">
        <h3 style="margin: 0; color: #333; display: inline;">操作失误开到股票账户就需要，注意接听华宝证券客服回访电话， </h3>
        <h3 style="margin: 0; color: #333; display: inline;">如果错过回访电话或者自己不想一直等来电 </h3>
        <h3 style="margin: 0; color: #ff0000; display: inline;">可以本人自己主动致电下 4008209898 转到人工客服说一下完成开户回访</h3>
      </div>
      <h1 style="margin-bottom: 16px; color: #333;">常见问题解答：</h1>
      <h3 style="margin-bottom: 16px; color: #333;">什么是LOF套利</h3>
      <h4 style="margin-bottom: 16px; color: #333;">就是利用上市型开放式基金（LOF）在场内交易价格和场外基金净值之间的差价来获利的一种方法</h4>
      <h4 style="margin-bottom: 16px; color: #333;">打个比喻就是超市场和超市一样，菜市场进菜超市卖菜</h4>
      <h3 style="margin-bottom: 16px; color: #333;">哪些可以套利</h3>
      <h4 style="margin-bottom: 16px; color: #333;">1.有溢价 2.限额申购，通常限额100</h4>
      <h3 style="margin-bottom: 16px; color: #ff0000;">是不是稳赚，肯定不是</h3>
      <h4 style="margin-bottom: 16px; color: #333;">肯定不是，只是相对的比股票之类的稳定，没有什么绝对安全，如果有肯定是骗你的，社群只是一个交流的渠道，自己注意甄别信息，警惕广告诈骗，大家都是成年人，要学会自己去判断识别。入市有风险，投资需谨慎。</h4>
      <h3 style="margin-bottom: 16px; color: #333;">为什么用华宝玩套利</h3>
      <h4 style="margin-bottom: 16px; color: #333;">1.支持一拖六，可以同时注册六个股东账户 </h4>
      <h4 style="margin-bottom: 16px; color: #333;">2.可以一个手机同时操作多个账户 </h4>
      <h4 style="margin-bottom: 16px; color: #333;">3.费率低，申购费率1折，场内卖出免5 </h4>

      <h3 style="margin-bottom: 16px; color: #333;">怎么看套利申购到账的份额是亏钱还是赚钱？</h3>
      <h4 style="margin-bottom: 16px; color: #333;">最简单的方式就是看券商的盈亏数据，但可能会存在偏差，想要更细致的数据可以像文章开头那样，通过查看交割单记录每一笔套利申购、卖出数据。</h4>
      <h3 style="margin-bottom: 16px; color: #333;">套利是一定赚钱吗？</h3>
      <h4 style="margin-bottom: 16px; color: #333;">不一定，看到的溢价只是纸面上的富贵，实际收益受到账时间的价格波动等客观因素的影响，也有一定的概率亏钱</h4>
      <h3 style="margin-bottom: 16px; color: #333;">套利为什么最好用交易费用低的券商？</h3>
      <h4 style="margin-bottom: 16px; color: #333;">一个账号每次套利的利润可能只有几元到几十元，参考文章开头的套利记录，我是使用申购费率1折、场内卖出mian5的账户操作的，如果是普通费率的账户，成本需要翻10倍都不止，大家可以算算还剩多少收益，基本就是在给券商打工。</h4>
      <h3 style="margin-bottom: 16px; color: #333;">操作步骤</h3>
      <h4 style="margin-bottom: 16px; color: #333;">华宝-》交易-》场内基金-》场内申购</h4>
      <h3 style="margin-bottom: 16px; color: #333;">申购买卖时间</h3>
      <h4 style="margin-bottom: 16px; color: #333;">在交易日（T日）15:00之前</h4>
      <h3 style="margin-bottom: 16px; color: #333;">申购到账时间</h3>
      <h4 style="margin-bottom: 16px; color: #333;">一般是T+2/T+3,目前白银市T+2到账，其余是T+3</h4>
      <h3 style="margin-bottom: 16px; color: #333;">为什么要一拖六</h3>
      <h4 style="margin-bottom: 16px; color: #333;">因为套利风险较低的基金大部分都是限额100元左右，所以想增加单户的套利收益就需要想办法增加单日申购的份额。</h4>
      <h3 style="margin-bottom: 16px; color: #333;">到底要不要一拖六，什么是一拖六</h3>
      <h4 style="margin-bottom: 16px; color: #333;">取决于基金本身，例如白银，限制身份证了就不能一拖六，没有限制就可以一拖六</h4>
      <h3 style="margin-bottom: 16px; color: #333;">一拖六就是一个账户，在申购时候选择六个股东账户，反之则只选一个</h3>
      <h3 style="margin-bottom: 16px; color: #333;">申购到账后要不要囤</h3>
      <h4 style="margin-bottom: 16px; color: #333;">一般情况是不建议囤，套利赚的就是落袋为安，减少不确定性，当然也不是绝对的，也可以根据自行情况去判断持有的LOF未来会不会继续涨，再去绝对还要不要继续持有，还是 直接卖</h4>
      <h3 style="margin-bottom: 16px; color: #333;">为什么会有没到账情况</h3>
      <h4 style="margin-bottom: 16px; color: #333;">1.新注册账户，第一天不能使用，导致申购失败</h4>
      <h4 style="margin-bottom: 16px; color: #333;">2.多平台同时申购了同一个限制身份证的，会导致失败</h4>
      <h4 style="margin-bottom: 16px; color: #333;">3.超出限额申购</h4>
      <h4 style="margin-bottom: 16px; color: #333;">4.未完待续。。。</h4>
      <h3 style="margin-bottom: 16px; color: #333;">为什么会有停牌</h3>
      <h4 style="margin-bottom: 16px; color: #333;">主要是因为价格异常波动触发市场风控机制，简单理解就是涨的太狠了，给你降降温，无视就好，该怎么做就继续怎么做</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterPage',
  data() {
    return {
      huabapRegImg: require('@/assets/huabapReg.png'), 
      licaiImg : require('@/assets/licai.png'), 
      zhanghuleixingImg : require('@/assets/zhanghuleixing.jpg'), 
      kaihushouliImg : require('@/assets/kaihushouli.png'), 
      feishuDocUrl: 'https://wcnui8a5lcos.feishu.cn/wiki/VIlBwrd9wiePkLkvL3Pc4rpenJv?from=from_copylink',
      iframeLoading: true,
      showFallback: false
    }
  },
  methods: {
    onIframeLoad() {
      this.iframeLoading = false
      // 如果 iframe 加载失败，显示备用内容
      setTimeout(() => {
        try {
          const iframe = this.$el.querySelector('.feishu-iframe')
          if (iframe && iframe.contentWindow) {
            // 尝试访问 iframe 内容，如果失败说明被跨域阻止
            iframe.contentWindow.document
          }
        } catch (e) {
          // 跨域阻止，显示备用提示
          this.showFallback = true
        }
      }, 2000)
    }
  }
}
</script>

<style scoped>
.table-container {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.feishu-doc-container {
  width: 100%;
}

.doc-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.doc-link {
  margin-top: 12px;
}

.external-link {
  color: #409eff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  transition: color 0.3s;
}

.external-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.feishu-iframe-wrapper {
  position: relative;
  width: 100%;
  min-height: 800px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f7fa;
}

.feishu-iframe {
  width: 100%;
  height: 100%;
  min-height: 800px;
  border: none;
}

.iframe-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #909399;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.fallback-content {
  margin-top: 16px;
}

.inline-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 4px;
}

.inline-heading h3 {
  margin: 0 !important;
  display: inline !important;
}

@media (max-width: 768px) {
  .feishu-iframe-wrapper {
    min-height: 600px;
  }
  
  .feishu-iframe {
    min-height: 600px;
  }
}
</style>

